document.querySelectorAll('[data-shop-hero]').forEach((hero) => {
  const track = hero.querySelector('.shop-hero-carousel__track');
  if (!track || track.children.length < 2) return;
  const move = (direction) => track.scrollBy({left: direction * track.clientWidth, behavior: 'smooth'});
  hero.querySelector('[data-hero-prev]')?.addEventListener('click', () => move(-1));
  hero.querySelector('[data-hero-next]')?.addEventListener('click', () => move(1));
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let timer;
  const stop = () => window.clearInterval(timer);
  const start = () => {
    stop();
    timer = window.setInterval(() => {
      const last = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      track.scrollTo({left: last ? 0 : track.scrollLeft + track.clientWidth, behavior: 'smooth'});
    }, 7000);
  };
  hero.addEventListener('mouseenter', stop);
  hero.addEventListener('mouseleave', start);
  hero.addEventListener('focusin', stop);
  hero.addEventListener('focusout', start);
  start();
});
